import { useSubscription } from "@apollo/client";
import { useDispatch } from "react-redux";
import { CACHE_WAS_RESET } from "components/settings/subscriptions/index";
import { INVALIDATE_USER_INFO } from "actions/actionTypes/index";
import { INVALIDATE_USER_RIGHTS } from "features/userRights/actionTypes";
import { INVALIDATE_GLOBAL_PARAMS } from "features/params/globalParams/actionTypes";

const GlobalSubscriptionArea = () => {
  const dispatch = useDispatch();

  useSubscription(CACHE_WAS_RESET, {
    onData: () => {
      dispatch({ type: INVALIDATE_GLOBAL_PARAMS });
      dispatch({ type: INVALIDATE_USER_INFO });
      dispatch({ type: INVALIDATE_USER_RIGHTS });
    }
  });
  return "";
};

export default GlobalSubscriptionArea;
